import React from 'react'

export default function index() {
  return (
    <div>Edit Client Information</div>
  )
}
